import { pageDto } from "./pagedto";
import { RateModelDto } from './ratemodeldto';

export class RateModelResponse {

    listRateModelDto: RateModelDto[] = [];

    pageDto: pageDto = new pageDto({});

}